import { render } from "./PackingExpressRuleManage.vue?vue&type=template&id=0aef969a"
import script from "./PackingExpressRuleManage.vue?vue&type=script&lang=js"
export * from "./PackingExpressRuleManage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__